import { edgeScrim } from "./edge-color.ts";

export const overlayMotionClassName =
    "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 data-[state=open]:ease-out-quint data-[state=closed]:ease-out-quint data-[state=closed]:pointer-events-none!";

export const DIALOG_SCRIM = edgeScrim("bg-doberman-black/45");

export const dialogOverlayClassName = `fixed inset-0 z-50 ${DIALOG_SCRIM.className} backdrop-blur-[2px] data-[state=open]:duration-[180ms] data-[state=closed]:duration-[210ms] motion-reduce:animate-none ${overlayMotionClassName}`;
